import { render, staticRenderFns } from "./PaymentsReport.vue?vue&type=template&id=27a0e5a2"
import script from "./PaymentsReport.vue?vue&type=script&lang=js"
export * from "./PaymentsReport.vue?vue&type=script&lang=js"
import style0 from "./PaymentsReport.vue?vue&type=style&index=0&id=27a0e5a2&prod&lang=scss"
import style1 from "./PaymentsReport.vue?vue&type=style&index=1&id=27a0e5a2&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports